import React from "react";

function ShareCard({
  total,
  totalPlus,
  throwScoringModeId,
  calculateShareStats,
  eventName,
  playerName,
}) {
  const shareStats = calculateShareStats();

  return (
    <div
      id="share-card"
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        marginBottom: "20px",
        textAlign: "center",
        maxWidth: "400px",
        margin: "0 auto 20px auto",
        boxShadow: "0 4px 12px rgba(45, 8, 63, 0.15)",
        overflow: "hidden",
      }}
    >
      {/* Purple Header */}
      <div
        style={{
          backgroundColor: "#2D083F",
          padding: "20px 24px 15px 24px",
          color: "#ffffff",
        }}
      >
        <h3
          style={{
            color: "#ffffff",
            marginBottom: "8px",
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          🥏 Disc Golf Scorecard
        </h3>
        {playerName && (
          <div
            style={{
              color: "#cccccc",
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "0",
            }}
          >
            {playerName}
          </div>
        )}
      </div>

      {/* White Middle Section */}
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px 24px",
          color: "#2D083F",
        }}
      >
        {/* Event Name Display */}
        <div
          style={{
            fontSize: "24px",
            fontWeight: "800",
            color: "#2D083F",
            textAlign: "center",
            marginBottom: "16px",
            textTransform: "uppercase",
            letterSpacing: "1.2px",
          }}
        >
          {eventName || "Event"}
        </div>

        <div
          style={{
            fontSize: "28px",
            fontWeight: "900",
            color: "#2D083F",
            marginBottom: "20px",
          }}
        >
          Final Score: {throwScoringModeId > 1 ? totalPlus : total}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            marginBottom: "20px",
            padding: "0 10px",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "24px", marginBottom: "5px" }}>✔️</div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#2D083F",
              }}
            >
              {shareStats.throwScoreCounts[2]}
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                fontWeight: "600",
              }}
            >
              Makes
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "24px", marginBottom: "5px" }}>⛓️</div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#2D083F",
              }}
            >
              {shareStats.throwScoreCounts[1]}
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                fontWeight: "600",
              }}
            >
              Metal
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "24px", marginBottom: "5px" }}>🚫</div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#2D083F",
              }}
            >
              {shareStats.throwScoreCounts[0]}
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                fontWeight: "600",
              }}
            >
              Misses
            </div>
          </div>
        </div>
        <div
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            color: "#2D083F",
            marginBottom: "0",
          }}
        >
          🎯 Make Rate: {shareStats.makeRate.toFixed(1)}%
        </div>
      </div>

      {/* Purple Footer */}
      <div
        style={{
          backgroundColor: "#2D083F",
          padding: "15px 24px 20px 24px",
          color: "#cccccc",
        }}
      >
        <div
          style={{
            fontSize: "14px",
            color: "#cccccc",
            fontWeight: "600",
          }}
        >
          #DiscGolf #Scorecard #KPLeagues
        </div>
      </div>
    </div>
  );
}

export default ShareCard;
